/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Col_LinkInputs */

const vi_shop_account_col_link = /** @type {(inputs: Shop_Account_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách hàng ERP`)
};

/**

* @param {Shop_Account_Col_LinkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_col_link = /** @type {((inputs?: Shop_Account_Col_LinkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Col_LinkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_col_link(inputs)
});